<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  @import '@zz/sasscore/mixins/ellipsis.scss';
  @import '../../assets/styles/common.scss';
  .new-zz-qc-info-ab {
    .report_person {
      position: relative;
      background: #fff;
      padding: 36px 30px 0px 32px;
      box-sizing: border-box;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      .person_title {
        .title {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #111;
          line-height: 38px;
        }
        .code {
          margin-top: 12px;
          font-size: 20px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #999;
          line-height: 20px;
        }
        .copy-icon {
          height: 20px;
          width: 20px;
          position: relative;
          top: 1px;
          margin-left: 5px;
        }
      }

      .person_photo {
        position: relative;
        margin-top: -8px;
        .teacher-msg {
          display: flex;
          position: relative;
          justify-content: center;
          width: 80px;
          height: 80px;
          background-color: #f8f8f8;
          border-radius: 80px;
          margin: 0 auto;
          overflow: hidden;
          &_avatar {
            width: 80px;
            height: 80px;
            margin: 0 auto;
          }

          .unit {
            position: absolute;
            height: 25px;
            width: 25px;
            bottom: 0;
            margin-bottom: -3px;
            margin-left: 42px;
          }
        }
        .teacher-msg_name {
          position: relative;
          text-align: center;
          font-size: 18px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #999;
          line-height: 18px;
          margin-top: 16px;
          .name {
            margin: 0 0 7px;
            line-height: 18px;
            .teacher-msg_name-arrow {
              width: 8px;
              height: 14px;
              margin-left: -4px;
            }
          }
          .name2 {
            line-height: 18px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            .teacher-msg_name-arrow {
              width: 8px;
              height: 14px;
              margin-left: -4px;
            }
          }
          .teacher-msg_mask {
            position: absolute;
            left: 0;
            top: -10px;
            z-index: -1;
            width: 100%;
            height: auto;
          }
        }
        .teacher-msg_finish {
          position: absolute;
          // bottom: -8px;
          top: 34px;
          left: -100px;
          z-index: 999;
          width: 112px;
          height: 112px;
        }
      }
    }
    .quality-icon {
      height: 120px;
      width: 120px;
      position: absolute;
      right: 0;
      margin-right: 45px;
      margin-top: -40px;
      z-index: 100;
    }
    .quality-content {
      padding: 0 32px 16px;
      border-radius: 16px;
      background: #fff;
      .qc-condition {
        position: relative;
        display: flex;
        align-items: center;
        padding-top: 19px;
        box-sizing: border-box;
        .condition-left {
          margin-right: 4px;
          display: flex;
          align-items: center;
          font-size: 58px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: bold;
          color: #111;
          span {
            display: inline-block;
          }
          .number {
            position: relative;
            top: 10px;
            margin-right: 8px;
            font-weight: 500;
            font-family: Akrobat-ExtraBold, Akrobat;
            &.super {
              line-height: 46px;
              font-size: 64px;
              font-family: Akrobat-ExtraBold, Akrobat;
              font-weight: 500;
              color: #111;
              line-height: 48px;
            }
            &.isNotNumber {
              font-size: 40px;
              margin-top: -6px;
              margin-right: 4px;
            }
          }
          .ab-base-desc {
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 400;
            color: #111111;
            position: relative;
            top: -3px;
          }
        }
        .ab-condition-right {
          padding: 12px 0 8px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999;
          line-height: 20px;
          &_spuer {
            height: 50px;
          }
          p {
            line-height: 20px;
            img {
              width: 18px;
            }
          }
        }
      }
      .qc-info {
        .info {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 16px;
          &::after {
            content: '';
            width: 188px;
          }
          .ab-detail-item {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            box-sizing: border-box;
            position: relative;
            width: calc(100% / 3);
            &:nth-of-type(3n) {
              padding-left: 24px;
            }
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              min-width: 200%;
              height: 200%;
              border-bottom: 1px solid #f0f0f0;
              transform-origin: 0 0;
              transform: scale(0.5, 0.5);
            }
            .value {
              @include ellipsis(2);

              margin-top: 28px;
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #111;
              line-height: 34px;
            }
            .key {
              margin-top: 14px;
              margin-bottom: 28px;
              font-size: 20px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 300;
              color: #999999;
              line-height: 20px;
              display: flex;
              align-items: center;
              text-overflow: ellipsis;
              .tips {
                margin-left: 4px;
                position: relative;
                top: 0.5px;
                .z-tip-trigger {
                  display: flex;
                }
              }
              .name_question {
                width: 18px;
                height: 18px;
              }
            }
          }
          .ab-detail-item:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .qc_result_wrapper {
      display: flex;
      overflow: hidden;
    }
    .qc_result {
      position: relative;
      max-height: 3.2em;
      overflow: hidden;
      line-height: 1.8;
      text-overflow: ellipsis;
      padding-top: 26px;
      color: #666;
      font-size: 22px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      padding-top: 18px;

      .span-detail {
        position: relative;
        top: 2px;
        width: 96px;
        height: 28px;
        margin-right: 6px;
        margin-bottom: -4px;
      }
    }
    .qc_result::before {
      float: right;
      height: calc(100% - 30px);
      content: '';
    }
    .float-right {
      position: relative;
      top: 0;
      float: right;
      clear: both;
      color: #999999;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      .dot {
        margin-right: 10px;
      }
      .expand-text {
        top: -1px;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        &::before {
          top: -3px;
        }
      }
    }
    .expand-text {
      position: relative;
      // text-decoration: underline;

      color: #666;
      line-height: 20px;
      font-size: 20px;
      &::before {
        content: '';
        position: absolute;
        top: -4px;
        left: 0;
        min-width: 200%;
        height: 200%;
        border-bottom: 1px solid #999;
        transform-origin: 0 0;
        transform: scale(0.5, 0.5);
      }
    }
  }
</style>

<template>
  <div class="new-zz-qc-info-ab">
    <div v-if="!fromMicroDetail" class="report_person">
      <div class="person_title">
        <div class="title">{{ dataInfo.report.title }}</div>
        <div
          v-if="dataInfo.report.qcCode"
          v-zpm="{
            sectionid: 116,
            sortid: 2,
            sortname: '复制',
          }"
          class="code"
          @click="copyFn"
        >
          验机编号：{{ dataInfo.report.qcCode }}
          <img
            class="copy-icon"
            :src="
              $setPicSize(
                'https://pic6.zhuanstatic.com/zhuanzh/0ae4324f-c8a9-46d3-b880-bafdba3d9b6e.png'
              )
            "
            alt=""
          />
        </div>
      </div>

      <!-- 质检侧未提供最新头像 8.17收官需求暂时采用旧方案 -->

      <div
        v-zpm="{
          sectionid: 171,
          sortid: 0,
          sortname: '质检师头像',
        }"
        class="person_photo"
        @click="jumpUrl()"
      >
        <div v-if="omsType === warehousing">
          <div class="teacher-msg">
            <img class="teacher-msg_avatar" :src="qualityTeacherMsg.icon" alt="" />
          </div>
        </div>
        <div v-else>
          <div class="teacher-msg">
            <img
              class="teacher-msg_avatar"
              :src="qualityTeacherMsg.omsSceneEngineerAvatar"
              alt=""
            />
          </div>
        </div>

        <div class="teacher-msg_name">
          <div v-if="omsType === warehousing">
            <p class="name">
              {{ qualityTeacherMsg.title }} {{ qualityTeacherMsg.name }}
              <img
                class="teacher-msg_name-arrow"
                :src="
                  $setPicSize(
                    'https://pic4.zhuanstatic.com/zhuanzh/be98fe85-9cd2-41b1-b8df-83ec56e41abe.png',
                    112
                  )
                "
                alt=""
              />
            </p>
            <p class="desc">{{ qualityTeacherMsg.entryDesc }}</p>
          </div>
          <div v-else>
            <p class="name">
              {{ qualityTeacherMsg.omsSceneEngineerTitle }}
            </p>
            <p class="name2">
              {{ qualityTeacherMsg.omsSceneEngineerName }}
              <img
                class="teacher-msg_name-arrow"
                :src="
                  $setPicSize(
                    'https://pic4.zhuanstatic.com/zhuanzh/be98fe85-9cd2-41b1-b8df-83ec56e41abe.png',
                    112
                  )
                "
                alt=""
              />
            </p>
          </div>

          <!-- <img
            class="teacher-msg_mask"
            :src="
              $setPicSize(
                'https://pic2.zhuanstatic.com/zhuanzh/79b5ae28-aa23-4bd5-a9b5-4d17329acdd7.png',
                112
              )
            "
            alt=""
          /> -->
        </div>
        <img
          class="teacher-msg_finish"
          :src="
            $setPicSize(
              'https://pic2.zhuanstatic.com/zhuanzh/dd9bca68-3be7-4e9c-b384-d645b55bc922.png',
              112
            )
          "
          alt=""
        />
      </div>
    </div>
    <div class="quality-content">
      <div v-if="Object.keys(conditionDescAndNum).length > 0" class="qc-condition">
        <div
          v-zpm="{
            sectionid: 116,
            sortid: 3,
            sortname: '等级',
          }"
          class="condition-left"
          @click="toggleConditionPopup"
        >
          <span
            v-if="conditionDescAndNum.number"
            class="number"
            :class="{
              super: !conditionDescAndNum.desc,
              isNotNumber: !/^\d+$/.test(conditionDescAndNum.number),
            }"
            >{{ conditionDescAndNum.number }}</span
          >
          <span v-if="conditionDescAndNum.desc" class="ab-base-desc">{{
            conditionDescAndNum.desc
          }}</span>
        </div>
        <div
          v-if="conditionDescAndNum.desc || conditionDescAndNum.number"
          v-zpm="{
            sectionid: 116,
            sortid: 4,
            sortname: '等级',
          }"
          class="ab-condition-right"
          :class="{ 'ab-condition-right_spuer': conditionDescAndNum.desc }"
          @click="toggleConditionPopup"
        >
          <p>
            <img
              v-if="
                dataInfo.type != 1 &&
                dataInfo.report.conditionIntro &&
                dataInfo.report.conditionIntro.data &&
                dataInfo.report.conditionIntro.data.length
              "
              :src="
                $setPicSize(
                  'https://pic2.zhuanstatic.com/zhuanzh/33320be8-da2e-4300-99ca-b4f0590aacc5.png'
                )
              "
            />
          </p>
          <!-- <p v-if="dataInfo.infoLv.summary">{{ dataInfo.infoLv.summary }}</p> -->
        </div>
      </div>
      <div v-if="descInfo" class="qc_result_wrapper">
        <div
          ref="goodsTitle"
          v-zpm="{
            sectionid: 116,
            legoareabackup: {
              sortName: '质检结论',
              sortId: 0,
            },
            areaexposure: 116,
          }"
          class="qc_result"
        >
          <label v-show="showTitleCheckMore" class="float-right">
            <span v-show="!titleExpand" class="dot">...</span>
            <span
              v-show="!titleExpand"
              v-zpm="{
                sectionid: 116,
                sortid: 0,
                sortname: '质检结论展开',
              }"
              class="expand-text"
              @click="showAllTitle"
              >展开</span
            >
          </label>
          <img
            class="span-detail"
            :src="
              $setPicSize(
                'https://pic1.zhuanstatic.com/zhuanzh/e14de073-2d7b-4501-bad8-df78a462b7ad.png'
              )
            "
          />
          {{ descInfo }}
          <span
            v-show="titleExpand"
            v-zpm="{
              sectionid: 116,
              sortid: 0,
              sortname: '质检结论收起',
            }"
            class="expand-text"
            @click="showAllTitle"
            >收起</span
          >
        </div>
      </div>

      <div class="qc-info">
        <div v-if="nineParams" class="info">
          <div v-for="(item, index) in nineParams" :key="index" class="ab-detail-item">
            <p class="value value-new">
              <span class="item_span">{{
                item.key === 'IMEI' ? calculateIMEI(item.value) : item.value
              }}</span>
            </p>
            <p class="key">
              {{ item.key }}
              <span
                v-if="item.qcWiki"
                v-zpm="{
                  sectionid: 130,
                  sortid: index,
                  sortname: item.key,
                }"
                class="tips"
                @click="tipsClick(item)"
              >
                <img
                  class="name_question"
                  :src="
                    $setPicSize(
                      'https://pic3.zhuanstatic.com/zhuanzh/280e9ecd-2f3c-444b-a7a7-5a832773342c.png'
                    )
                  "
                />
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <QualityInspectorDialog :show.sync="showQualityInspectorDialog" :info="qualityTeacherMsg" />
  </div>
</template>
<script>
  import { setPicSize } from '@zz-common/zz-utils'
  import copy from '../../utils/copy'

  import { formatVal } from '../../utils'
  import { Toast } from '@zz-common/zz-ui'
  import { skipToUrl } from '../../utils/native'
  import QualityInspectorDialog from './QualityInspectorDialog'
  import { warehousing } from '../config'

  export default {
    props: {
      dataInfo: {
        type: Object,
        default: () => {},
      },
      fromMicroDetail: {
        type: Boolean,
        default: false,
      },
      omsType: {
        type: Number,
        default: undefined,
      },
    },
    data() {
      return {
        unfold: false,
        showExpandButton: false, // 是否展示展开按钮
        showTitleCheckMore: false,
        titleExpand: false,
        showQualityInspectorDialog: false,
        warehousing,
      }
    },
    components: {
      QualityInspectorDialog,
    },
    computed: {
      qualityTeacherMsg() {
        const { qcUser = {} } = this.dataInfo.report || {}
        if (Object.keys(qcUser).length > 0) {
          return qcUser
        }
        return ''
      },
      $setPicSize() {
        return setPicSize
      },
      nineParams() {
        return this.dataInfo.report.params && this.dataInfo.report.params.filter((it) => it.value)
      },
      conditionDescAndNum() {
        let desc = ''
        let number = ''
        const { infoLv } = this.dataInfo
        // 订单快照页面进入质检报告场景
        if (!infoLv || Object.keys(infoLv).length == 0) {
          const { finenessDialogContents = [], finenessLevelValueId = '' } =
            this.dataInfo.report.conditionIntro

          if (finenessDialogContents && finenessDialogContents.length) {
            const info = (finenessDialogContents || []).find(
              ({ valueId }) => valueId === finenessLevelValueId
            )
            number = formatVal(info?.finenessName)?.ms1
            desc = formatVal(info?.finenessName)?.ms2
          } else {
            if (this.dataInfo.report && this.dataInfo.report.condition) {
              const finenessName = this.dataInfo.report.condition
              number = formatVal(finenessName)?.ms1
              desc = formatVal(finenessName)?.ms2
            }
          }
        }
        if (infoLv && infoLv.level) {
          number = formatVal(infoLv.level).ms1
          desc = formatVal(infoLv.level).ms2
        }
        return {
          desc,
          number,
        }
      },
      descInfo() {
        return `${this.dataInfo.report.checkDesc || ''}${
          this.dataInfo.report.checkDescSuffix || ''
        }`
      },
    },
    mounted() {
      this.$nextTick(() => {
        const titleCheckMoreEl = this.$refs.goodsTitle || {}
        if (titleCheckMoreEl.scrollHeight - titleCheckMoreEl.clientHeight > 5) {
          this.showTitleCheckMore = true
        }
      })
    },
    methods: {
      showAllTitle() {
        if (this.showTitleCheckMore) {
          if (!this.titleExpand) {
            this.$refs.goodsTitle.style.maxHeight = 'none'
            this.titleExpand = true
          } else {
            this.$refs.goodsTitle.style.maxHeight = '3.2em'
            this.titleExpand = false
          }
        }
      },
      calculateIMEI(imei) {
        let result = ''
        result = `${imei.slice(0, 3)}***${imei.slice(imei.length - 3, imei.length)}`
        return result
      },
      toggleConditionPopup() {
        this.$emit('toggle')
      },
      tipsClick(data) {
        this.$emit('toggleTips', data)
      },
      onUnfold() {
        this.unfold = !this.unfold
      },
      copyFn() {
        copy(this.dataInfo.report.qcCode).then((code) => {
          code ? Toast('复制成功') : Toast('复制失败~')
        })
      },
      /**
       * $ 收官项目需求 质检师头像跳转到质检师详情页
       * 文档地址：https://doc.weixin.qq.com/doc/w3_AFoAqwYoAOMgfgjmp2xQliny41WOo?scode=AJ4AfQfgAAw9kTDqiEALcA3gYwAE4
       */
      jumpUrl() {
        if (this.omsType === this.warehousing) {
          const jumpParams = {
            name: this.qualityTeacherMsg.name,
            job: this.qualityTeacherMsg.jobName || undefined,
            age: this.qualityTeacherMsg.entryDesc || undefined,
            id: this.qualityTeacherMsg.employeeNum || undefined,
            pic: this.qualityTeacherMsg.icon || undefined,
            marks: this.qualityTeacherMsg.marks || undefined,
            title: this.qualityTeacherMsg.introduceTitle || undefined,
            titleIcon: this.qualityTeacherMsg.introduceTitleIcon || undefined,
            desc: this.qualityTeacherMsg.introduceContent || undefined,
            pageTitle: '验机师介绍',
          }
          console.log(jumpParams, '-------->>>   jumpUrl', this.qualityTeacherMsg)
          const data = `https://act.zhuanzhuan.com/platform/zz-platform-pages/check/appraiser-card?needHideHead=3&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.5&data=${encodeURIComponent(
            JSON.stringify(jumpParams)
          )}`
          skipToUrl({
            targetUrl: data,
          })
        } else {
          this.showQualityInspectorDialog = true
        }
      },
    },
  }
</script>
